import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=0bcf5b16&scoped=true&"
import script from "./Roadmap.vue?vue&type=script&lang=js&"
export * from "./Roadmap.vue?vue&type=script&lang=js&"
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=0bcf5b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf5b16",
  null
  
)

export default component.exports